import { plumbingSubserviceFlowConfig } from './mockData/plumbingSubserviceFlows';
import { hvacSubserviceFlowConfig } from './mockData/hvacSubserviceFlows';
import { electricalSubserviceFlowConfig } from './mockData/electricalSubserviceFlows';
import { landscapingSubserviceFlowConfig } from './mockData/landscapingSubserviceFlows';

/**
 * Question configs from the earlier per-trade wizard, kept so saved search requests
 * (account page, admin waitlist, request summaries) still show readable answers.
 * New searches use the service search flow (`components/ServiceSearchFlow`).
 * Keys match `serviceType`.
 */
export const wizardServiceRegistry = {
  plumbing: {
    serviceType: 'plumbing',
    serviceLabel: 'Plumbing',
    flowConfig: plumbingSubserviceFlowConfig,
  },
  hvac: {
    serviceType: 'hvac',
    serviceLabel: 'HVAC',
    flowConfig: hvacSubserviceFlowConfig,
  },
  electrical: {
    serviceType: 'electrical',
    serviceLabel: 'Electrical',
    flowConfig: electricalSubserviceFlowConfig,
  },
  landscaping: {
    serviceType: 'landscaping',
    serviceLabel: 'Landscaping',
    flowConfig: landscapingSubserviceFlowConfig,
  },
};

/**
 * @param {string | null | undefined} serviceType
 * @returns {{ serviceType: string, serviceLabel: string, flowConfig: object } | null}
 */
export function getWizardServiceConfig(serviceType) {
  return wizardServiceRegistry[serviceType] ?? null;
}
